(() => {
  const initialize = (root) => {
    if (root.dataset.supportReady) return;
    root.dataset.supportReady = 'true';
    const controller = new AbortController();
    const { signal } = controller;
    const rail = root.querySelector('.ks-rail');
    const links = [...root.querySelectorAll('[data-support-jump]')];
    const groups = [...root.querySelectorAll('[data-support-group]')];
    const header = document.querySelector('#shopify-section-static-header');
    const input = root.querySelector('[data-support-input]');
    let clearSearch = () => {};
    let frame = 0;
    const update = () => {
      frame = 0;
      if (!root.isConnected) { controller.abort(); return; }
      const offset = Math.round(header ? Math.max(0, header.getBoundingClientRect().bottom) : 0) + 12;
      root.style.setProperty('--ks-offset', `${offset}px`);
      const visible = groups.filter((group) => !group.hidden);
      const line = offset + (window.innerWidth < 720 ? rail.offsetHeight : 0) + 36;
      const active = visible.find((group) => group.getBoundingClientRect().bottom > line) || visible[visible.length - 1];
      links.forEach((link) => {
        if (active && link.dataset.supportJump === active.id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };
    const schedule = () => { if (!frame) frame = window.requestAnimationFrame(update); };
    if (input) {
      const questions = [...root.querySelectorAll('[data-support-question]')];
      const searchable = new Map(questions.map((question) => [question, question.textContent.toLocaleLowerCase()]));
      const clear = root.querySelector('[data-support-clear]');
      const status = root.querySelector('[data-support-status]');
      const empty = root.querySelector('[data-support-empty]');
      let savedOpen = null;
      const filter = () => {
        const query = input.value.trim().toLocaleLowerCase();
        if (query && savedOpen === null) savedOpen = new Map(questions.map((question) => [question, question.open]));
        const terms = query.split(/\s+/).filter(Boolean);
        let count = 0;
        questions.forEach((question) => {
          const matches = terms.every((term) => searchable.get(question).includes(term));
          question.hidden = !matches;
          if (matches) count += 1;
          if (query) question.open = matches;
          else if (savedOpen) question.open = savedOpen.get(question);
        });
        if (!query) savedOpen = null;
        groups.forEach((group) => {
          group.hidden = ![...group.querySelectorAll('[data-support-question]')].some((question) => !question.hidden);
          const link = links.find((item) => item.dataset.supportJump === group.id);
          if (link) link.hidden = group.hidden;
        });
        clear.hidden = !query;
        empty.hidden = !query || count > 0;
        status.textContent = query ? status.dataset.countTemplate.replace('[count]', String(count)) : '';
        update();
      };
      root.querySelector('[data-support-search]').hidden = false;
      input.addEventListener('input', filter, { signal });
      clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); }, { signal });
      clearSearch = () => { input.value = ''; filter(); };
    }
    links.forEach((link) => link.addEventListener('click', (event) => {
      const group = groups.find((item) => item.id === link.dataset.supportJump);
      if (!group) return;
      event.preventDefault();
      clearSearch();
      const jump = () => {
        update();
        const offset = parseFloat(getComputedStyle(root).getPropertyValue('--ks-offset')) || 0;
        const railHeight = window.innerWidth < 720 ? rail.offsetHeight : 0;
        window.scrollTo({ top: window.scrollY + group.getBoundingClientRect().top - offset - railHeight - 12, behavior: 'instant' });
      };
      jump();
      window.requestAnimationFrame(() => { jump(); update(); });
      window.history.replaceState(null, '', `#${group.id}`);
      group.setAttribute('tabindex', '-1');
      group.focus({ preventScroll: true });
    }, { signal }));
    window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', schedule, { signal });
    root.addEventListener('toggle', schedule, { capture: true, signal });
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(root)) { controller.abort(); window.cancelAnimationFrame(frame); }
    }, { signal });
    document.addEventListener('shopify:block:select', (event) => {
      const question = event.target.closest('[data-support-question]');
      if (question && root.contains(question)) question.open = true;
    }, { signal });
    update();
  };
  const initializeAll = () => document.querySelectorAll('[data-knox-support]').forEach(initialize);
  initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
